import axios from 'axios';

const instance = () => {
  const authData = localStorage.getItem('auth');
  const apiUrl =
    window.location.hostname === 'www.jetsuite.com'
      ? 'https://js-api.jetsuite.com'
      : 'https://api-dev.jetsuite.com';
  if (authData !== null) {
    return axios.create({
      baseURL: apiUrl,
      headers: { Authorization: 'Bearer ' + JSON.parse(authData).token }
    });
  }

  return axios.create({
    baseURL: apiUrl
  });
};

export default instance;



// WEBPACK FOOTER //
// ./src/axios-instance.js